export default {"src":"/_next/static/media/diamond.a6de6835.svg","height":83,"width":90,"blurWidth":0,"blurHeight":0};